// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
